import { Availability } from "./availability";

export interface IWorkShift {
  availabilities: Availability[];
  userMappingID: string;
  name: string;
  busNumbers: string;
  dateKey: string;
  displayOrder: number;
}
export class WorkShift implements IWorkShift {

  availabilities: Availability[];

  userMappingID: string;
  name: string;
  busNumbers: string;
  dateKey: string;
  displayOrder: number;

  public constructor(workShift: IWorkShift) {
    this.name = workShift.name;
    this.userMappingID = workShift.userMappingID;
    this.busNumbers = workShift.busNumbers;
    this.availabilities = workShift.availabilities;
    this.dateKey = workShift.dateKey;
    this.displayOrder = workShift.displayOrder;
  }

  public isWithinWorkingHours(date: Date): boolean {

    let startDates = this.availabilities.map(a => a.start.getTime());
    let endDates = this.availabilities.map(a => a.end.getTime());

    let minDate = Math.min(...startDates);
    let maxDate = Math.max(...endDates);

    if (date.getTime() >= minDate && date.getTime() <= maxDate)
      return true;

    return false;
  }

  // returns true if start or end is within workshift
  public isWorkingWithinTimespan(start: Date, end: Date)
  {
    let availabilities = this.availabilities.filter(a => a.isWorkingWithinTimespan(start, end));

    if (availabilities.length > 0) return true;

    return false;
  }

  // returns true if startTime and endTime is withing workshift
  public isWorkingByTime(startTime: number, endTime: number) {
    let availabilities = this.availabilities.filter(a => a.isWorkingByTime(startTime, endTime));

    if (availabilities.length > 0) return true;

    return false;
  }

  public isWorking(date: Date): boolean{
    return this.isWorkingByTime(date.getTime(), date.getTime());
  }

  public findAvailabilityForByTime(start: number, end: number): Availability[] | undefined {

    let foundItems = this.availabilities.filter(a => a.start.getTime() <= start && a.end.getTime() >= end);

    if (foundItems.length == 0) return undefined;

    if (foundItems.length == 1) return foundItems;

  }

  // Merges availabilities that connect directly (e.g. a shift split at midnight)
  // into continuous segments. Separate shifts with a gap stay separate.
  public getContinuousSegments(): { start: Date, end: Date }[] {
    const sorted = [...this.availabilities].sort(
      (a, b) => a.start.getTime() - b.start.getTime()
    );

    const segments: { start: Date, end: Date }[] = [];

    for (const a of sorted) {
      const last = segments[segments.length - 1];
      if (last && a.start.getTime() <= last.end.getTime()) {
        if (a.end.getTime() > last.end.getTime()) {
          last.end = a.end;
        }
      } else {
        segments.push({ start: a.start, end: a.end });
      }
    }

    return segments;
  }

  public getBusNumbers(): string {

    const descending = [...this.availabilities.map(a => Availability.toTypeSafe(a))].sort(
      (a, b) => a.start.getTime() - b.start.getTime()
    );

    let busnumbers = descending.map(a => Availability.toMetaExpanded(a.meta).BusNumber).join(", ");
    return busnumbers;
  }

  public getBusForCurrentAvailability(): string {
    const now = new Date().getTime();
    const currentAvailability = this.findAvailabilityForByTime(now, now);

    if (currentAvailability) {
      return currentAvailability[0].metaExpanded.BusNumber;
    }
    return "";
  }

  public get start(): Date {
    let startDates = this.availabilities.map(a => a.start.getTime());
    let minDate = Math.min(...startDates);
    const date = new Date();
    date.setTime(minDate);
    return date;
  }

  public get end(): Date {
    let endDates = this.availabilities.map(a => a.end.getTime());
    let maxDate = Math.max(...endDates);
    const date = new Date();
    date.setTime(maxDate);
    return date;
  }
}
